export default __webpack_public_path__ + "static/media/ancailinciuin2.e5af0083.jpeg";